import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rules: {
      required: [{
        required: true,
        message: '此输入框必填',
        trigger: 'blur'
      }]
    },
    // 用户名称
    nickName: '',
    // 用户身份
    userType: ''
  },
  mutations: {
    changeNickName (state, val = '') {
      state.nickName = val
    },
    changeUserType (state, val) {
      state.userType = val
    }
  },
  actions: {}
})
